<template>
  <div class="mt120">
    <div class="container">
      <p>Retrospective Weekly Form</p>
    </div>
    <Footer />
    <FooterSmall />
    <scrollBack />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue"
import FooterSmall from "@/components/FooterSmall.vue"
import scrollBack from "@/components/scrollBack.vue"

export default {
  name: "tech",
  components: {
    Footer,
    FooterSmall,
    scrollBack
  },
  data: function () {
    return {
    }
  }
};
</script> 

<style lang="scss" scoped>
.container {
  height: 500px;
}
</style>
